import { bankruptcyTerminationActionTypes as actionTypes } from '../ActionTypes/bankruptcyTerminationActionTypes';
import { apiThunk } from '../Utils/apiThunk';
import type { components } from '../Types/api';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyDispatch = any;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyGetState = () => any;

type PagedJobs = components['schemas']['Cockpit.Models.Pagination.PagedResult`1[Cockpit.Models.Termination.BankruptcyTermination.BankruptcyJobListItemDto]'];
type BankruptcyJobDetailDto = components['schemas']['Cockpit.Models.Termination.BankruptcyTermination.BankruptcyJobDetailDto'];
type UpdateManuallyHandledRequest = components['schemas']['Cockpit.Models.Termination.BankruptcyTermination.UpdateManuallyHandledRequest'];

const bankruptcyTerminationActions = {
    getJobs(page: number, pageSize: number) {
        return (dispatch: AnyDispatch) =>
            dispatch(
                apiThunk<PagedJobs>(`/api/BankruptcyTermination/GetJobs?page=${page}&pageSize=${pageSize}`, {
                    loadingKey: 'bankruptcyJobs',
                })
            ).then((data: PagedJobs | null) => {
                if (data) dispatch({ type: actionTypes.STORE_BANKRUPTCY_JOBS, data });
            });
    },

    getJobDetail(jobId: number, page: number, pageSize: number) {
        return (dispatch: AnyDispatch) =>
            dispatch(
                apiThunk<BankruptcyJobDetailDto>(`/api/BankruptcyTermination/GetJobDetails/${jobId}?page=${page}&pageSize=${pageSize}`, { loadingKey: 'bankruptcyJobDetail' })
            ).then((data: BankruptcyJobDetailDto | null) => {
                if (data) dispatch({ type: actionTypes.STORE_BANKRUPTCY_JOB_DETAIL, data });
            });
    },

    setManuallyHandled(customerResultId: number, value: boolean | null) {
        return (dispatch: AnyDispatch, getState: AnyGetState) => {
            const results = getState().BankruptcyTerminationReducer.customerResults as Array<{ id: number; manuallyHandled: boolean | null }> | undefined;
            const previous = results?.find((c) => c.id === customerResultId)?.manuallyHandled ?? null;

            dispatch({ type: actionTypes.SET_MANUALLY_HANDLED, customerResultId, value });
            const body: UpdateManuallyHandledRequest = { manuallyHandled: value };
            return dispatch(
                apiThunk<void>(`/api/BankruptcyTermination/UpdateManuallyHandled/customer/${customerResultId}/manually-handled`, {
                    init: { method: 'PATCH', body: JSON.stringify(body) },
                    rethrow: true,
                })
            ).catch(() => {
                // Revert the optimistic update; apiThunk already surfaced the error toast.
                dispatch({ type: actionTypes.SET_MANUALLY_HANDLED, customerResultId, value: previous });
            });
        };
    },
};

export default bankruptcyTerminationActions;
